import { useEffect, useState } from 'react';
import PageBodyWrapper from '../../components/PageBodyWrapper'
import { GraphQLPagination, StatusBar } from '../../components/common';
import { useSearchParams } from 'react-router-dom';
import useApi from '../../api';
import StockFilter from '../../components/stocks/StockFilter';
import { getQueryVariables } from '../../utils';
import StockTransferTable from '../../components/stocks/stockTransferTable';
import { gql } from "@apollo/client";
import { useQuery } from "@apollo/client";
import StackTransferForm from './stockTransferForm';


const GET_STOCK_TRANSFERS = gql`
  query GetStockTransfers(
    $first: Int
    $last: Int
    $after: String
    $before: String
  ) {
    stockTransfers(
      first: $first
      last: $last
      after: $after
      before: $before
    ) {
      edges {
        node {
          dbId
          status
          createdAt
          lastModified
          fromWarehouse {
            name
          }
          toWarehouse {
            name
          }
        }
        cursor
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
`;

function StockTransfer() {
  const [stocks, setStocks] = useState<any>()
  const [isOpenStockCreateForm, setIsOpenStockCreateForm] = useState<boolean>(false)
  const [isOpenStockFilter, setISOpenStockFilter] = useState<boolean>(false)
  const [searchParams, setSearchParams] = useSearchParams();
  const [openModal, setOpenModal] = useState<boolean>(false);
  
  const api = useApi()
  
  const [filterData, setFilterData] =  useState<any>({});

  const { data, loading, error, refetch } = useQuery(GET_STOCK_TRANSFERS, {
    variables: getQueryVariables(searchParams),
    notifyOnNetworkStatusChange: true,
  });

  const changeStatus = (status: string) => {
    const newParams = new URLSearchParams(searchParams);
    newParams.set("status", status);
    newParams.set("page", "1"); 
    setSearchParams(newParams);
  };

  const toggleStockCreateForm = () => {
    setIsOpenStockCreateForm(!isOpenStockCreateForm)
  }


  useEffect(() => {
    if (!searchParams.get("first") && !searchParams.get("last")) {
      setSearchParams({ first: "20" });
    }
  }, []);


  const fetchStockTransfers = () => {
    refetch();
  }


  return (
    <PageBodyWrapper>
      
      <StatusBar
        onButtonClick={() => setOpenModal(!openModal)}
        statusList={[]}
        buttonLabel="Transfer Stock"
        fieldName="status"
      />

      {isOpenStockFilter && <StockFilter isOpen={isOpenStockFilter} onClose={()=>setIsOpenStockCreateForm(!isOpenStockFilter)}/>}

      <StockTransferTable data={data?.stockTransfers?.edges || []} refresh={fetchStockTransfers}/>

      <GraphQLPagination 
        edges={data?.stockTransfers?.edges || []}
        pageInfo={data?.stockTransfers?.pageInfo || {}}
      />


      {openModal && <StackTransferForm refresh={fetchStockTransfers} isOpen={openModal} onClose={()=>setOpenModal(!openModal)}/>}
      
    </PageBodyWrapper>
  )
}

export default StockTransfer